<template>
    <div class="tw-flex-1">
        <div v-bar>
            <div>
                <div class="tw-text-center tw-flex tw-flex-col tw-flex-1 tw-items-center tw-justify-center">
                    <h1 class="tw-text-2xl tw-font-bold tw-mb-4 secondary-c">{{quiz.title}}</h1>
                    <p class="tw-text-base tw-text-gray-500 tw-mb-6 tw-pb-6 tw-border-b tw-border-gray-0 tw-mx-8 tw-px-4">{{quiz.description}}</p>
                    <div class="tw-flex tw-flex-col tw-text-sm tw-text-gray-300">
                        <div class="quiz-meta-item">
                            <i class="fa fa-question-square"></i>
                            <span>{{ questionsLength }} {{ translations['quiz.questions'] }}</span>
                        </div>
                        <div class="quiz-meta-item" v-if="quizSettings.timer_on === '1'">
                            <i class="fa fa-clock"></i>
                            <span>{{ quizSettings.timer }} {{ translations['quiz.minutes'] }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Global  from '../../../mixins/Global.js';

    export default{
        mixins: [Global],
        name: "QuizTop",

        props: ['quiz', 'quizSettings'],

        computed: {
            questionsLength() {
                return this.$store.getters['quiz/getAmountOfQuestions'];
            },
        },
    }
</script>

<style lang="scss" scoped>
    .vb {
        height: 100%;
    }

    .vb-content {
        display: flex !important;
    }

    .quiz-wrapper {
        h1 {
            background: none !important;
            border: 0 !important;
            padding: 0 !important;
            margin-bottom: 1rem !important;
        }

        .quiz-meta-item {
            @apply tw-flex tw-items-center tw-pb-3;

            i {
                @apply tw-pr-2 tw-text-xl;
            }

            span {
                @apply tw-font-semibold;
            }

            &:last-of-type {
                @apply tw-pb-0;
            }
        }
    }
</style>